type ChevronDownIconProps = {
  width?: number;
  height?: number;
};

export const ChevronDownIcon = ({ width = 24, height = 24 }: ChevronDownIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.59 8.59009L12 13.1701L7.41 8.59009L6 10.0001L12 16.0001L18 10.0001L16.59 8.59009Z"
      fill="currentColor"
    />
  </svg>
);
